import { Navigate } from 'react-router-dom';

import { NBA_MARKET_INSTANT_BUY } from '@sorare/core/src/constants/__generated__/routes';

export const Market = () => {
  return <Navigate to={NBA_MARKET_INSTANT_BUY} />;
};

export default Market;
